import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoubleArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#CAD5E3",
		fillRule: "nonzero",
		d: "M11.78 1.28 7.06 6l4.72 4.72a.75.75 0 0 1-1.06 1.06L5.47 6.53a.75.75 0 0 1 0-1.06L10.72.22a.75.75 0 0 1 1.06 1.06M5.405 2.405 1.811 6l3.594 3.595a.75.75 0 0 1-1.06 1.06L.22 6.53a.75.75 0 0 1 0-1.06l4.125-4.125a.75.75 0 0 1 1.06 1.06"
	})
});
export default SvgDoubleArrowLeft;
